import { POSTAL_CODE_REGEX } from '@/constants/regex';
import { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { initialState, NewAddressUi } from './NewAddressUi';

export function useNewAddressViewController(
  onAddressChanged: (newAddress: NewAddressUi) => void
) {
  const [uiState, setUiState] = useImmer<NewAddressUi>(initialState);

  const onChangeStreet = (newValue: string) =>
    setUiState((prev) => {
      prev.street = newValue;
      prev.streetError = prev.street.trim() ? undefined : 'Calle inválida';
    });

  const onChangeAddressTag = (newValue: string) =>
    setUiState((prev) => {
      prev.addressTag = newValue;
      prev.addressTagError = prev.addressTag.trim()
        ? undefined
        : 'Sucursal o identificador inválido';
    });

  const onExternalNumberChanged = (newValue: string) =>
    setUiState((draft) => {
      draft.externalNumber = newValue;
      draft.externalNumberError = draft.externalNumber.trim()
        ? undefined
        : 'Número exterior inválido';
    });

  const onInternalNumberChanged = (newValue: string) =>
    setUiState((draft) => {
      draft.internalNumber = newValue;
    });

  const onPostalCodeChanged = (newValue: string) =>
    setUiState((draft) => {
      draft.postalCode = newValue;
      draft.postalCodeError = POSTAL_CODE_REGEX.test(draft.postalCode)
        ? undefined
        : 'Código postal inválido';
    });

  const onColoniaChanged = (newValue: string) =>
    setUiState((draft) => {
      draft.colonia = newValue;
      draft.coloniaError = draft.colonia.trim()
        ? undefined
        : 'Colonia inválida';
    });

  useEffect(() => {
    onAddressChanged(uiState);
  }, [uiState]);

  return {
    uiState,
    actions: {
      onChangeStreet,
      onChangeAddressTag,
      onExternalNumberChanged,
      onInternalNumberChanged,
      onPostalCodeChanged,
      onColoniaChanged,
    },
  };
}
